/**
 * Top-level markdown tokens for splitting a chat reply into prose, code and Jarvis pieces (fd-rich-chat PH-01).
 * Its own module so the renderer can be mocked in tests without touching the splitter. Fence detection does not
 * depend on the renderer's options, so a separate parser instance sees exactly the same fences.
 */
export interface MarkdownToken {
  type: string;
  raw: string;
  lang?: string;
  text?: string;
}

let lexer: ((src: string) => MarkdownToken[]) | null = null;
let loading: Promise<void> | null = null;

export function initLexer(): Promise<void> {
  if (lexer) return Promise.resolve();
  if (!loading) {
    loading = import('marked').then((mod) => {
      const instance = new mod.Marked({ gfm: true, breaks: true });
      lexer = (src: string) => instance.lexer(src) as unknown as MarkdownToken[];
    });
  }
  return loading;
}

/** Top-level tokens, or null until the parser has loaded (callers then treat the text as one markdown run). */
export function lexMarkdown(src: string): MarkdownToken[] | null {
  if (!lexer) {
    void initLexer();
    return null;
  }
  return lexer(src);
}
